import { render, staticRenderFns } from "./priceTable.vue?vue&type=template&id=46224c64&scoped=true"
import script from "./priceTable.vue?vue&type=script&lang=js"
export * from "./priceTable.vue?vue&type=script&lang=js"
import style0 from "./priceTable.vue?vue&type=style&index=0&id=46224c64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46224c64",
  null
  
)

export default component.exports